import React from 'react'
import { Button, Card, Confirm, Embed, Form, Icon, Image, Modal } from 'semantic-ui-react'
import { inlineStyle } from '../../../styles/custom'
import PermissionsManager from '../../PermissionsManager'

// Convert octets
const FileConvertSize = (aSize) => {
  aSize = Math.abs(parseInt(aSize, 10))
  var def = [[1, 'octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']]
  for (var i=0; i < def.length; i++) {
    if (aSize<def[i][0]) {
      return (aSize/def[i-1][0]).toFixed(2) + ' ' + def[i-1][1]
    }
  }
}

const renderPreview = (media) => {
  const text = (media.file) ? media.file.split(/#|\?/)[0].split('.').pop().trim().toUpperCase() : 'Pas d\'aperçu'
  const defaultPreview = 'http://via.placeholder.com/350x274?text=' + text
  if (media.type === 'image') {
    return <Image src={ media.file !== null ? media.file : defaultPreview } />
  } else if (media.type === 'audio') {
    if (media.file !== null) {
      return <Embed placeholder={defaultPreview} url={media.file}/>
    } else {
      return <Image src={defaultPreview} />
    }
  } else {
    return <Image src={defaultPreview} />
  }
}

const renderMedias = (obj, medias, status, onChange, onSubmit, onDelete, onOpenModal, onClick) => {
  if (status.loadingMedias) {
    return <div>Chargement</div>
  }

  if (!medias || medias.length === 0) {
    return <div>Aucun enregistrement</div>
  }

  return (
    <Card.Group itemsPerRow={4}>
      {medias.map(media => {
        return (
          <Card key={media.id} onClick={(event, data) => onClick(event, media)}>
            {renderPreview(media)}
            <Card.Content>
              <Card.Meta>
                {media.type === 'image' ? <Icon name='file image outline' /> : media.type === 'audio' ? <Icon name='file audio outline' /> : <Icon name='file outline' />}
                {media.name}
              </Card.Meta>
              <Card.Description>
                {FileConvertSize(media.size)}
              </Card.Description>
            </Card.Content>
            <Card.Content extra>
              <Button onClick={(e) => { window.open(media.file, '_blank') }} floated='left' icon size='tiny'><Icon name="eye" /></Button>
              <PermissionsManager hasPermissions={['update_media']}>
                <Modal trigger={<Button floated='left' icon size='tiny' color='green' onClick={(event, data) => { onOpenModal(event, media) } }><Icon name="edit" /></Button>} style={inlineStyle.modal}>
                  <Modal.Header>Modification du média (#{media.id})</Modal.Header>
                  <Modal.Content>
                    <Modal.Description>
                      <Form>
                        <Form.Field>
                          <Form.Input label='Nom du média' placeholder="Nom du média" id="name" value={(obj) ? (obj.name) ? obj.name : '' : '' } onChange={onChange} />
                        </Form.Field>
                        <Button type='submit' color='olive' onClick={onSubmit}><Icon name="save" /> Sauvegarder</Button>
                      </Form>
                    </Modal.Description>
                  </Modal.Content>
                </Modal>
              </PermissionsManager>
              <PermissionsManager hasPermissions={['delete_media']}>
                <Button type='submit' icon size='tiny' floated='right' color='red' onClick={(event, data) => { onDelete(event, { id: media.id, confirm: true }) }}><Icon name="delete" /></Button>
                <Confirm
                  content='Êtes-vous sûr(e) de vouloir supprimer ce média ? Cette action est définitive.'
                  open={status.deletion.confirm}
                  onCancel={(event, data) => { onDelete(event, { confirm: null }) }}
                  onConfirm={(event, data) => { onDelete(event, { id: media.id, confirm: false }) }}
                  style={inlineStyle.modal}
                  cancelButton='Annuler'
                  confirmButton='Ok'
                />
              </PermissionsManager>
            </Card.Content>
          </Card>
        )
      })}
    </Card.Group>
  )
}

const List = ({...props}) => {
  if ((!props.medias || props.medias.length === 0) && !props.isSearch) {
    return <p>Aucun enregistrement</p>
  }

  return (
    <div>
      <Form>
        <Form.Field>
          <Form.Input icon='search' fluid placeholder='Search...' id="q" value={props.isSearch} onChange={props.onSearch} />
        </Form.Field>
        <br/>
      </Form>
      {renderMedias(props.obj, props.medias, props.status, props.onChange, props.onSubmit, props.onDelete, props.onOpenModal, props.onClick)}
    </div>
  )
}

export default List



// WEBPACK FOOTER //
// ./src/components/list/media/list.js